<h4 class="fs-5 fw-bold">
  {{ 'title.additional-questions' | translate }}
</h4>
<div class="row">
  <div class="col-12 col-lg-6">
    <p>
      <strong>
        {{
          'booking.sdv.additional-questions-page.universityDetails.question'
            | translate
        }}
      </strong>
    </p>
    <p>
      {{
        booking.additionalQuestionData?.universityDetails
          ?.name
      }}
    </p>
  </div>

  <div class="col-12 col-lg-6">
    <p>
      <strong>
        {{
          'booking.sdv.additional-questions-page.studiesDetails.subject.question'
            | translate
        }}
      </strong>
    </p>
    <p>
      {{
        booking.additionalQuestionData?.studiesDetails
          ?.subject
      }}
    </p>
  </div>
</div>

<p>
  <strong>
    {{
      'booking.sdv.additional-questions-page.schoolDetails.question'
        | translate
    }}
  </strong>
</p>
<p>
  <span>
    {{
      booking.additionalQuestionData?.schoolDetails
        ?.name
    }}
  </span>
  <br />
  <span>
    {{
      booking.additionalQuestionData?.schoolDetails?.zip
    }}
  </span>
  <span>
    {{
      booking.additionalQuestionData?.schoolDetails
        ?.city
    }}
  </span>
  <br />
  <span>
    {{
      booking.additionalQuestionData?.schoolDetails
        ?.state
    }}
  </span>
  <span>
    {{
      booking.additionalQuestionData?.schoolDetails
        ?.country
    }}
  </span>
</p>
